import {Component, Input} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-loading',
  template: `
    <div class="d-flex align-items-center gap-15">
      <div class="spinner-grow"
           [ngClass]="customClass"
           [style]="size === 'small' ? 'width: 1rem; height: 1rem;' : 'width: 3rem; height: 3rem;'" role="status">
        <span class="sr-only"></span>
      </div>
      @if (text) {
        <div>{{ text | translate }}</div>
      }
    </div>
  `,
  standalone: true,
  imports: [
    TranslateModule,
    NgClass
  ]
})
export class LoadingComponent {
  @Input() size = '';
  @Input() text = '';
  @Input() customClass = '';

}
